import * as React from 'react';
import { Grid, Title } from '@siteground/styleguide';

const ChatLogo = () => (
  <Grid align="center">
    <Title level="4" weight="bold">
      SiteGround Chat
    </Title>
  </Grid>
);

export default ChatLogo;
